import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizeParser, LocalizeRouterService } from 'localize-router';
import { forkJoin, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { StorageService } from '../../../app/shared/_services/storage.service';
import { Gradino } from '../../../app/shared/_model/Gradino';
import { ApiService, ProdottoCarrello } from '../../../app/shared/_services/api.service';
import { CarrelloService } from '../../.../../../app/shared/_services/carrello.service';
import { AlertService } from '../../../app/shared/_services/alert.service.';

@Component({
  selector: 'app-card-list-configuratore',
  templateUrl: './card-list-configuratore.component.html',
  styles: []
})
export class CardListConfiguratoreComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private api: ApiService,
    private localize: LocalizeRouterService,
    private carrelloService: CarrelloService,
    private alertService: AlertService,
    private router: Router
    ) { }

  strutturaGradinatore;
  queryParamsGradinatore;
  mobileConfiguratoreShow = true;

  modalShow = false;
  schedaTempModale;

  schede = [];

  ngOnInit() {
    this.strutturaGradinatore = this.route.snapshot.data.GradinatoreResolver;

    this.route.queryParams.subscribe(p => {
      if (p.step0) {
        setTimeout(() => { this.queryParamsGradinatore = p; }, 0);
      }
    });
  }

  risultatiChange(ids: number[]) {
    const cdLingua = this.localize.parser.currentLang.toUpperCase();
    const chiamate = ids.map(idConfiguratore => this.api.schedaGetScheda({idConfiguratore, cdLingua}));
    forkJoin(chiamate).subscribe(schede => {
      schede.forEach(scheda => { if (scheda.foto && scheda.foto instanceof Array) { scheda.foto = scheda.foto.find(foto => foto.principale); } });
      this.schede = schede.filter(scheda => scheda.stato === 1);
    });
  }

  risultatiStaffeChange(gradini: Gradino[]) {
    const cdLingua = this.localize.parser.currentLang.toUpperCase();
    const chiamate = gradini.map(({modello}) => this.api.schedaGetScheda({idConfiguratore: modello.codice, cdLingua}));
    forkJoin(chiamate).subscribe(schede => {
      this.schede = schede
        .filter(scheda => scheda.stato === 1)
        .map(scheda => {
          if (scheda.foto && scheda.foto instanceof Array) {
            scheda.foto = scheda.foto.find(foto => foto.principale);
          }
          const gradino = gradini.find(g => g.modello.codice === scheda.idConfiguratore);
          if (gradino) {
            scheda.staffaPortiera = gradino.staffaPortiera ? gradino.staffaPortiera : null;
            scheda.staffaTelaio = gradino.staffaTelaio ? gradino.staffaTelaio : null;
            scheda.idPercorso = gradino.percorsoId;
          }
          scheda.showAcquista = true;
          return scheda;
        });
    });
  }


  aggiungiAlCarrello(scheda, forza = false) {
    const cdLingua = this.localize.parser.currentLang.toUpperCase();

    if (((scheda.staffaTelaio  && scheda.staffaTelaio.codice === 'XXXX') || (scheda.staffaPortiera && scheda.staffaPortiera.codice === 'XXXX')) && !forza) {
      this.modalShow = true;
      this.schedaTempModale = scheda;
      return;
    }

    // Tutto sto giro serve a trasformare le staffe provenienti dal gradinatore in schede del cms
    of({}).pipe(
      switchMap( () => {
        if (scheda.staffaPortiera && scheda.staffaPortiera.codice !== 'XXXX') {
          return this.api.schedaGetScheda({idConfiguratore: scheda.staffaPortiera.codice, cdLingua});
        } else {
          return of(null);
        }
      }),
      switchMap( schedaPortiera => {
        if (scheda.staffaTelaio  && scheda.staffaTelaio.codice !== 'XXXX') {
          return this.api.schedaGetScheda({idConfiguratore: scheda.staffaTelaio.codice, cdLingua}).pipe(map(schedaTelaio => ({schedaPortiera, schedaTelaio})));
        } else {
          return of({schedaPortiera, schedaTelaio: null});
        }
      })
    ).subscribe((staffe) => {
      const prodotti: ProdottoCarrello[] = [{ idScheda: scheda.idScheda,  quantita: 1, idPercorso: scheda.idPercorso || 0 } ];
      if (staffe.schedaPortiera) { prodotti.push({ idScheda: staffe.schedaPortiera.idScheda,  quantita: 1, idSchedaPadre: scheda.idScheda, idPercorso: scheda.idPercorso || 0 }); }
      if (staffe.schedaTelaio) { prodotti.push({ idScheda: staffe.schedaTelaio.idScheda,  quantita: 1, idSchedaPadre: scheda.idScheda, idPercorso: scheda.idPercorso || 0 }); }

      this.carrelloService.salvaProdotti(prodotti).subscribe(() => this.alertService.apriAlert.emit('ARTICOLO_AGGIUNTO_AL_CARRELLO'));
      this.modalShow = false;
    });
  }

}
